import bestpractices from "../../../../assets/videos/blogs/pp21/bestpractices.mp4";
import * as React from 'react';
export default {
  bestpractices,
  React
};